var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "risk-detail-page" }, [
    _c("section", { staticClass: "detail-card overview-card" }, [
      _c("h3", { staticClass: "detail-title" }, [_vm._v("人员风控总览")]),
      _c("div", { staticClass: "overview-grid" }, [
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("客户名称")]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.row.sourceTypeName || "暂无")),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("人员姓名")]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.row.payeeName || "暂无")),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("身份证号")]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.row.idCard || "暂无")),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v("绑定用户数 / 预警阈值"),
          ]),
          _c("span", { staticClass: "value emphasis" }, [
            _vm._v(
              _vm._s(
                _vm.countThresholdText(_vm.row.bindUserCount, _vm.row.alarmNum)
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("风险状态")]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getDictValue(_vm.row.riskStatus, "risk_status"))),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("提现风控状态")]),
          _c("span", { staticClass: "value" }, [
            _vm._v(
              _vm._s(
                _vm.getDictValue(_vm.row.cashRiskStatus, "cash_risk_status")
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("提现申请合计")]),
          _c("span", { staticClass: "value" }, [
            _vm._v(
              _vm._s(
                _vm.amountText(_vm.row.cashApplyNum, _vm.row.cashApplyAmount)
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("成功提现合计")]),
          _c("span", { staticClass: "value success" }, [
            _vm._v(
              _vm._s(_vm.amountText(_vm.row.cashPayNum, _vm.row.cashPayAmount))
            ),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("风控拦截合计")]),
          _c("span", { staticClass: "value danger" }, [
            _vm._v(
              _vm._s(
                _vm.amountText(_vm.row.cashBlockNum, _vm.row.cashBlockAmount)
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "overview-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("最近提现时间")]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.row.lastCashTime || "暂无")),
          ]),
        ]),
      ]),
    ]),
    _c(
      "section",
      { staticClass: "detail-card user-detail-card" },
      [
        _c("h3", { staticClass: "detail-title" }, [_vm._v("绑定用户明细")]),
        _c("DetailList", { attrs: { propsObj: _vm.row } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }